module.exports = __webpack_public_path__ + "static/a-happy-couple-smiling-at-eachother.6c900d1d.webp";